import { Rect as d } from "./Rect.js";
const g = !!(typeof window < "u" && window.document && window.document.createElement);
class h {
  static instance = new h();
  /** @internal */
  _fDblClick;
  /** @internal */
  _fClick;
  /** @internal */
  _fDragEnd;
  /** @internal */
  _fDragMove;
  /** @internal */
  _fDragStart;
  /** @internal */
  _fDragCancel;
  /** @internal */
  _glass;
  /** @internal */
  _defaultGlassCursor;
  /** @internal */
  _glassCursorOverride;
  /** @internal */
  _manualGlassManagement = !1;
  /** @internal */
  _lastClick;
  /** @internal */
  _clickX;
  /** @internal */
  _clickY;
  /** @internal */
  _startX = 0;
  /** @internal */
  _startY = 0;
  /** @internal */
  _dragDepth = 0;
  /** @internal */
  _glassShowing = !1;
  /** @internal */
  _dragging = !1;
  /** @internal */
  _active = !1;
  // drag and drop is in progress, can be used on ios to prevent body scrolling (see demo)
  /** @internal */
  _document;
  /** @internal */
  _rootElement;
  /** @internal */
  _lastEvent;
  /** @internal */
  constructor() {
    g && (this._glass = document.createElement("div"), this._glass.style.zIndex = "998", this._glass.style.backgroundColor = "transparent", this._glass.style.outline = "none"), this._defaultGlassCursor = "default", this._onMouseMove = this._onMouseMove.bind(this), this._onMouseUp = this._onMouseUp.bind(this), this._onKeyPress = this._onKeyPress.bind(this), this._onDragCancel = this._onDragCancel.bind(this), this._onDragEnter = this._onDragEnter.bind(this), this._onDragLeave = this._onDragLeave.bind(this), this.resizeGlass = this.resizeGlass.bind(this), this._lastClick = 0, this._clickX = 0, this._clickY = 0;
  }
  // if you add the glass pane then you should remove it
  addGlass(t) {
    this._glassShowing ? this._manualGlassManagement = !0 : (this._document || (this._document = window.document), this._rootElement || (this._rootElement = this._document.body), this.resizeGlass(), this._document.defaultView?.addEventListener("resize", this.resizeGlass), this._document.body.appendChild(this._glass), this._glass.tabIndex = -1, this._glass.focus(), this._glass.addEventListener("keydown", this._onKeyPress), this._glass.addEventListener("dragenter", this._onDragEnter, { passive: !1 }), this._glass.addEventListener("dragover", this._onMouseMove, { passive: !1 }), this._glass.addEventListener("dragleave", this._onDragLeave, { passive: !1 }), this._glassShowing = !0, this._fDragCancel = t, this._manualGlassManagement = !1);
  }
  resizeGlass() {
    d.fromElement(this._rootElement).positionElement(this._glass, "fixed");
  }
  hideGlass() {
    this._glassShowing && (this._document.body.removeChild(this._glass), this._document.defaultView?.removeEventListener("resize", this.resizeGlass), this._glassShowing = !1, this._document = void 0, this._rootElement = void 0, this.setGlassCursorOverride(void 0));
  }
  /** @internal */
  _updateGlassCursor() {
    this._glass.style.cursor = this._glassCursorOverride ?? this._defaultGlassCursor;
  }
  /** @internal */
  _setDefaultGlassCursor(t) {
    this._defaultGlassCursor = t, this._updateGlassCursor();
  }
  setGlassCursorOverride(t) {
    this._glassCursorOverride = t, this._updateGlassCursor();
  }
  startDrag(t, s, e, i, a, _, l, n, o) {
    if (t && this._lastEvent && this._lastEvent.type.startsWith("touch") && t.type.startsWith("mouse") && t.timeStamp - this._lastEvent.timeStamp < 500)
      return;
    this._lastEvent = t, n ? this._document = n : this._document = window.document, o ? this._rootElement = o : this._rootElement = this._document.body;
    const r = this._getLocationEvent(t);
    this.addGlass(a), this._dragging && console.warn("this._dragging true on startDrag should never happen"), t ? (this._startX = r.clientX, this._startY = r.clientY, (!window.matchMedia || window.matchMedia("(pointer: fine)").matches) && this._setDefaultGlassCursor(getComputedStyle(t.target).cursor), this._stopPropagation(t), this._preventDefault(t)) : (this._startX = 0, this._startY = 0, this._setDefaultGlassCursor("default")), this._dragging = !1, this._fDragStart = s, this._fDragMove = e, this._fDragEnd = i, this._fDragCancel = a, this._fClick = _, this._fDblClick = l, this._active = !0, t?.type === "dragenter" ? (this._dragDepth = 1, this._rootElement.addEventListener("dragenter", this._onDragEnter, { passive: !1 }), this._rootElement.addEventListener("dragover", this._onMouseMove, { passive: !1 }), this._rootElement.addEventListener("dragleave", this._onDragLeave, { passive: !1 }), this._document.addEventListener("dragend", this._onDragCancel, { passive: !1 }), this._document.addEventListener("drop", this._onMouseUp, { passive: !1 })) : (this._document.addEventListener("mouseup", this._onMouseUp, { passive: !1 }), this._document.addEventListener("mousemove", this._onMouseMove, { passive: !1 }), this._document.addEventListener("touchend", this._onMouseUp, { passive: !1 }), this._document.addEventListener("touchmove", this._onMouseMove, { passive: !1 }));
  }
  isDragging() {
    return this._dragging;
  }
  isActive() {
    return this._active;
  }
  toString() {
    return "(DragDrop: startX=" + this._startX + ", startY=" + this._startY + ", dragging=" + this._dragging + ")";
  }
  /** @internal */
  _onKeyPress(t) {
    t.keyCode === 27 && this._onDragCancel();
  }
  /** @internal */
  _onDragCancel() {
    this._rootElement.removeEventListener("dragenter", this._onDragEnter), this._rootElement.removeEventListener("dragover", this._onMouseMove), this._rootElement.removeEventListener("dragleave", this._onDragLeave), this._document.removeEventListener("dragend", this._onDragCancel), this._document.removeEventListener("drop", this._onMouseUp), this._document.removeEventListener("mousemove", this._onMouseMove), this._document.removeEventListener("mouseup", this._onMouseUp), this._document.removeEventListener("touchend", this._onMouseUp), this._document.removeEventListener("touchmove", this._onMouseMove), this.hideGlass(), this._fDragCancel !== void 0 && this._fDragCancel(this._dragging), this._dragging = !1, this._active = !1;
  }
  /** @internal */
  _getLocationEvent(t) {
    let s = t;
    return t && t.touches && (s = t.touches[0]), s;
  }
  /** @internal */
  _getLocationEventEnd(t) {
    let s = t;
    return t.changedTouches && (s = t.changedTouches[0]), s;
  }
  /** @internal */
  _stopPropagation(t) {
    t.stopPropagation && t.stopPropagation();
  }
  /** @internal */
  _preventDefault(t) {
    return t.preventDefault && t.cancelable && t.preventDefault(), t;
  }
  /** @internal */
  _onMouseMove(t) {
    this._lastEvent = t;
    const s = this._getLocationEvent(t);
    return this._stopPropagation(t), this._preventDefault(t), !this._dragging && (Math.abs(this._startX - s.clientX) > 5 || Math.abs(this._startY - s.clientY) > 5) && (this._dragging = !0, this._fDragStart && (this._setDefaultGlassCursor("move"), this._dragging = this._fDragStart({ clientX: this._startX, clientY: this._startY }))), this._dragging && this._fDragMove && this._fDragMove(s), !1;
  }
  /** @internal */
  _onMouseUp(t) {
    this._lastEvent = t;
    const s = this._getLocationEventEnd(t);
    if (this._stopPropagation(t), this._preventDefault(t), this._active = !1, this._rootElement.removeEventListener("dragenter", this._onDragEnter), this._rootElement.removeEventListener("dragover", this._onMouseMove), this._rootElement.removeEventListener("dragleave", this._onDragLeave), this._document.removeEventListener("dragend", this._onDragCancel), this._document.removeEventListener("drop", this._onMouseUp), this._document.removeEventListener("mousemove", this._onMouseMove), this._document.removeEventListener("mouseup", this._onMouseUp), this._document.removeEventListener("touchend", this._onMouseUp), this._document.removeEventListener("touchmove", this._onMouseMove), this._manualGlassManagement || this.hideGlass(), this._dragging)
      this._dragging = !1, this._fDragEnd && this._fDragEnd(t);
    else if (this._fDragCancel && this._fDragCancel(this._dragging), Math.abs(this._startX - s.clientX) <= 5 && Math.abs(this._startY - s.clientY) <= 5) {
      let e = !1;
      const i = (/* @__PURE__ */ new Date()).getTime();
      Math.abs(this._clickX - s.clientX) <= 5 && Math.abs(this._clickY - s.clientY) <= 5 && i - this._lastClick < 500 && this._fDblClick && (this._fDblClick(t), e = !0), !e && this._fClick && this._fClick(t), this._lastClick = i, this._clickX = s.clientX, this._clickY = s.clientY;
    }
    return !1;
  }
  /** @internal */
  _onDragEnter(t) {
    return this._preventDefault(t), this._stopPropagation(t), this._dragDepth++, !1;
  }
  /** @internal */
  _onDragLeave(t) {
    return this._preventDefault(t), this._stopPropagation(t), this._dragDepth--, this._dragDepth <= 0 && this._onDragCancel(), !1;
  }
}
export {
  h as DragDrop
};
//# sourceMappingURL=DragDrop.js.map
